import {
  faCommentDots,
  faHandsAslInterpreting,
  faScrewdriverWrench,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ReactNode } from "react";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import { useTranslation } from "react-i18next";

type Props = {
  content_1: ReactNode;
  content_2: ReactNode;
  content_3: ReactNode;
  content_4: ReactNode;
};
function TabsComponent(props: Props) {
  const { t } = useTranslation("Tabs");
  return (
    <Tabs
      defaultActiveKey="Refine"
      id="uncontrolled-tab-example"
      className="mb-3"
    >
      <Tab
        eventKey="Refine"
        title={
          <>
            <FontAwesomeIcon icon={faScrewdriverWrench} /> {t("RefineTab")}
          </>
        }
      >
        {props.content_1}
      </Tab>
      <Tab
        eventKey="Explain"
        title={
          <>
            <FontAwesomeIcon icon={faCommentDots} /> {t("ExplainTab")}
          </>
        }
      >
        {props.content_2}
      </Tab>
      <Tab
        eventKey="Interpret"
        title={
          <>
            <FontAwesomeIcon icon={faHandsAslInterpreting} /> {t("InterpretTab")}
          </>
        }
      >
        {props.content_3}
      </Tab>
      <Tab
        eventKey="Chat"
        title={
          <>
            <FontAwesomeIcon icon={faHandsAslInterpreting} /> {t("ChatTab")}
          </>
        }
      >
        {props.content_4}
      </Tab>
    </Tabs>
  );
}

export default TabsComponent;
